import React from 'react';
import PropTypes from 'prop-types';

import * as ActPropTypes from 'types/act';

export default function IneligibleContactsComponent({
  ineligibleContacts,
  onClick,
  showing,
}) {
  return (
    <div className="act__ineligible-contacts">
      <p>
        <button
          className="ineligible-contacts__button"
          type="button"
          onClick={onClick}
          style={{ background: 'transparent', border: 'none' }}
        >
          <i className="fa fa-caret-right" />
          {' '}
          {`${showing ? 'Hide' : 'Show'} contacts I can't invite`}
        </button>
      </p>
      <div style={{ margin: '0 0 0 24px' }}>
        {showing && (
          <ul className="list--bulleted">
            {ineligibleContacts.map(({
              name,
              qualifies,
              correctInstance,
              youQualify,
            }) => (
              <li key={name}>
                {`${name} ${qualifies}${correctInstance}${youQualify}`}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

IneligibleContactsComponent.propTypes = {
  ineligibleContacts: PropTypes.arrayOf(ActPropTypes.ineligibleContact).isRequired,
  onClick: PropTypes.func.isRequired,
  showing: PropTypes.bool.isRequired,
};